export function flip(prob=0.5) {
    if (Math.random() < prob) {
        return true;
    }
    return false;
}

export function mate(sequencerEngine, name, data, param, prob=0.5) {
    if (data === undefined) {
        return;
    }
    if (flip(prob)) {
        let fullName = name + 'Parameter';
        if (fullName in data) {
            param.disconnectFromAllModulators();
            param.fromJson(data[fullName], sequencerEngine);
            param.set(data[name]);
        } else if (name in data){
            param.set(data[name]);
        }
    }
    // todo: mutate 
}
